export default __webpack_public_path__ + "static/tri-screen-lockup-v2-fe7b5ad76fcfdbebbecfe2b7bc1d90a8.png";